import { Injectable } from '@angular/core';

import {httpOptions} from '../../configurations/configuration';
import { HttpClient, HttpHeaders,HttpErrorResponse} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CertificationService {

  constructor(private http: HttpClient) { }

    getAllCertification(filterObj,start,limit){

        filterObj.languageId = localStorage.getItem('languageId');
        filterObj.languageId = undefined;


        let urlGetAllNews = environment.apiURL + environment.adminApiUrl + environment.getAllCertificationUrl +'?filter='+encodeURIComponent(JSON.stringify(filterObj))+'&start='+start+'&limit='+limit;
        return this.http.get<any>(urlGetAllNews)
        
    }
      
    updateCertification(postObj:any) : Observable<any> {

        postObj.langId = undefined;

        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.updateCertificationsUrl, postObj,httpOptions);
    }
          
    insertCertification(postObj:any) : Observable<any> {

        postObj.langId = undefined;

        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.insertCertificationUrl, postObj,httpOptions);
    } 

    getCertification( id: any) : Observable<any> {
      
        if(id){

        }
        else {
            id = 1;
        }

        return this.http.get(environment.apiURL + environment.adminApiUrl + environment.getCertificationUrl+"/" + id);
    }
    deleteCertification(postObj:any) : Observable<any> {
        postObj.langId = undefined;


        return this.http.post(environment.apiURL + environment.adminApiUrl + environment.deleteCertificationUrl, postObj,httpOptions);
    }






}
